import * as RadixRadio from '@radix-ui/react-radio-group';
import { useId, type ComponentPropsWithoutRef } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './RadioGroup.module.scss';

export interface RadioOption {
  value: string;
  label: string;
}

export interface RadioGroupProps extends Omit<
  ComponentPropsWithoutRef<typeof RadixRadio.Root>,
  'children'
> {
  options: readonly RadioOption[];
}

/**
 * Переключатели: все варианты видны сразу. Для трёх-шести вариантов это
 * быстрее выпадающего списка — не нужно открывать его, чтобы узнать, из чего
 * выбирать.
 */
export function RadioGroup({ options, className, ...rest }: RadioGroupProps) {
  const base = useId();

  return (
    <RadixRadio.Root className={cx(styles['group'], className)} {...rest}>
      {options.map((option, index) => {
        const id = `${base}-${String(index)}`;

        return (
          <div key={option.value} className={styles['option']}>
            <RadixRadio.Item id={id} value={option.value} className={styles['radio']}>
              <RadixRadio.Indicator className={styles['radio__dot']} />
            </RadixRadio.Item>
            <label htmlFor={id} className={styles['option__label']}>
              {option.label}
            </label>
          </div>
        );
      })}
    </RadixRadio.Root>
  );
}
